import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoShipmentReturnCode } from '@pit/frontend-model';
import { Observable } from 'rxjs';
import { DtoShipmentReturnCodeStoreFactory } from './dto.shipment.return.code.store.factory';

@Injectable()
export class DtoShipmentReturnCodeEffects extends EntityStoreEffects<IDtoShipmentReturnCode> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.shipment.return.code', actions$, DtoShipmentReturnCodeStoreFactory.instance, dataServiceAccessor);
    }

}
